module.exports = __webpack_public_path__ + "img/led_in_switch_65_fluffy.f74c9bc5.png";